import React, { CSSProperties, MouseEventHandler, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Icon } from '../icons/Icon';
import styles from './Card.module.scss';

export const Card = ({
    onClick, active,
    title, children, className,
    style
}: Props) => {

    const classes = classNames(styles.default, className, {
        [styles.active]: active,
        'idt-active': active,
        'idt-inactive': !active
    });

    return (
        <>
            <div style={style} className={classes} onClick={onClick}>
                {children}

                <div className={styles.checkmark}>
                    <Icon className={styles.icon} type='general-ui-checkmark' strokeWidth={3} />
                </div>
            </div>

            {title && (
                <p className={styles.name}>
                    {title}
                </p>
            )}
        </>
    );
};

type Props = PropsWithChildren<{
    onClick: MouseEventHandler;
    active?: boolean;
    className?: string;
    title?: string;
    style?: CSSProperties;
}>;